/**
 * Utility function to get the correct path for store images
 * Images should be placed in public/store/assets/images/
 * This is a pure function - same input always returns same output
 */
const imagePath = (imagePathValue) => {
  if (!imagePathValue) {
    return '/store/assets/images/product/large-size/1.jpg';
  }
  
  // If it's already a full URL, return as is
  if (imagePathValue.startsWith('http://') || imagePathValue.startsWith('https://')) {
    return imagePathValue;
  }
  
  // If it already starts with /store/assets/images/, return as is
  if (imagePathValue.startsWith('/store/assets/images/')) {
    return imagePathValue;
  }
  
  // Remove leading slash if present to avoid double slashes
  const cleanPath = imagePathValue.startsWith('/') ? imagePathValue.slice(1) : imagePathValue;
  return `/store/assets/images/${cleanPath}`;
};

// Export both names for backward compatibility
export { imagePath };
export const getImagePath = imagePath;
export default imagePath;
